module.exports = __webpack_public_path__ + "static/12-807428ce0c0641a0bfb6cdeacabb228a.png";